import { render, staticRenderFns } from "./BotSetting.vue?vue&type=template&id=3b222a64&scoped=true"
import script from "./BotSetting.vue?vue&type=script&lang=js"
export * from "./BotSetting.vue?vue&type=script&lang=js"
import style0 from "./BotSetting.vue?vue&type=style&index=0&id=3b222a64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b222a64",
  null
  
)

export default component.exports